module.exports = __webpack_public_path__ + "fonts/iconfont.f7f11bbb.ttf";